import { InjectionKey, Ref } from 'vue';
import { useEvent } from './composables/useEvent';
import { useEventSeries } from './composables/useEventSeries';
import { PendingLogo } from './composables/usePendingLogo';

export const fileUploadLoadingKey = Symbol() as InjectionKey<Ref<boolean>>;
export const iconKey = Symbol() as InjectionKey<Ref<{ url: string; fromParent: boolean }>>;
export const eventSeriesKey = Symbol() as InjectionKey<ReturnType<typeof useEventSeries> & PendingLogo>;
export const eventKey = Symbol() as InjectionKey<ReturnType<typeof useEvent> & PendingLogo>;
